import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReachIcon, ItemsIcon, CashIcon } from 'images'
import { numberWithThousandsSeparatorsWithCurrencyPrefix } from 'utils/helpers'
import { fetchBackhaulEvaluation } from 'api/backhaulEvaluation'
import { useParams } from 'react-router-dom'

export const useEvaluationResult = (reloadKey) => {
  const currency = useMemo(() => localStorage.getItem('userCurrency') || 'EUR', [])
  const { t } = useTranslation()
  const { packageId } = useParams()


  const getInfo = (clustersMap) => {
    const clusters = clustersMap || {}

    const totals = Object.values(clusters).reduce(
      (acc, cluster) => {
        const customers = cluster?.customers ?? 0
        const items = cluster?.items ?? 0
        const purchase = cluster?.purchase ?? 0

        return {
          customers: acc.customers + customers,
          items: acc.items + items,
          revenue: acc.revenue + purchase,
        }
      },
      { customers: 0, items: 0, revenue: 0 },
    )

    return [
      {
        title: t('PackageBuilder.packageBuilderResults.evaluationResults.customers'),
        value: totals.customers,
        icon: <ReachIcon width={22} height={22}/>,    
      },
      {
        title: t('PackageBuilder.packageBuilderResults.evaluationResults.items'),
        value: totals.items,
        icon: <ItemsIcon width={22} height={22}/>,
      },
      {
        title: t('PackageBuilder.packageBuilderResults.evaluationResults.revenue'),
        value: `${numberWithThousandsSeparatorsWithCurrencyPrefix(totals.revenue)} ${currency}`,
        icon: <CashIcon width={22} height={22}/>,
      },
    ]
  }

  const [evaluationData, setEvaluationData] = useState(null)
  const [error, setError] = useState(false)

  const getBackhaulEvaluation = async (id) => {
    const result = await fetchBackhaulEvaluation(id)

    if (result.success) {
      return result.data
    } else {
      setError(true)
    }

    return null
  }


  useEffect(() => {
    if (!packageId) return
    const load = async () => {
      const evaluation = await getBackhaulEvaluation(packageId)

      setEvaluationData(evaluation)
    }

    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageId, reloadKey])

  // return
  return {
    getInfo,
    evaluationData,
    currency,
    error,
  }
}